export namespace ICategoryTreeNodeMetadata {
  export enum CategoryGroup {
    CATEGORY_GROUP_UNKNOWN = 'CATEGORY_GROUP_UNKNOWN',
    APPAREL = 'APPAREL',
    ACCESSORIES = 'ACCESSORIES',
    FOOD_AND_BEVERAGE = 'FOOD_AND_BEVERAGE',
    OTHER_CATEGORY = 'OTHER_CATEGORY',
    HUB = 'HUB',
    /**
     * @deprecated
     */
    SDUI_HUB = 'SDUI_HUB',
    DIGEST_PAGE = 'DIGEST_PAGE',
  }

  /**
   * Return an instance of ICategoryTreeNodeMetadata with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ICategoryTreeNodeMetadata>
  ): ICategoryTreeNodeMetadata =>
    ({
      ...(partial ?? {}),
    }) as ICategoryTreeNodeMetadata;
}

export interface ICategoryTreeNodeMetadata {
  show_vertical_tile: boolean | undefined;
  has_square_images: boolean | undefined;
  is_alcohol_category: boolean | undefined;
  category_group:
    | keyof typeof ICategoryTreeNodeMetadata.CategoryGroup
    | undefined;
}
